import {
  TableCell,
  TableRow,
} from "src/components/ui/table";
import { PortalDsEmptyState } from "src/components/portal-design-system/portal-ds-empty-state";

interface CommissionTableEmptyStateProps {
  colSpan: number;
  title: string;
  description?: string;
}

/** Empty state row for commission data tables (keeps column headers visible). */
export function CommissionTableEmptyState({
  colSpan,
  title,
  description,
}: CommissionTableEmptyStateProps) {
  return (
    <TableRow>
      <TableCell colSpan={colSpan} className="p-0">
        <PortalDsEmptyState
          title={title}
          description={description}
          className="py-10"
        />
      </TableCell>
    </TableRow>
  );
}
